(() => {
  'use strict';
  if (window.raggieCareB02Initialized) return;
  window.raggieCareB02Initialized = true;
  const initialized = new WeakSet();
  const initialize = (root) => {
    for (const video of root.querySelectorAll('video[data-care-b02-video]')) {
      if (!(video instanceof HTMLVideoElement) || initialized.has(video)) continue;
      initialized.add(video);
      const landscapePoster = video.getAttribute('poster');
      const orient = (portrait) => {
        video.dataset.careOrientation = portrait ? 'portrait' : 'landscape';
        const poster = portrait ? video.dataset.mobilePoster : landscapePoster;
        if (poster && video.getAttribute('poster') !== poster) video.poster = poster;
      };
      const syncMetadata = () => {
        if (video.videoWidth > 0 && video.videoHeight > 0) {
          orient(video.videoHeight > video.videoWidth);
        }
      };
      video.addEventListener('loadedmetadata', syncMetadata);
      video.addEventListener('resize', syncMetadata);
      if (video.videoWidth > 0 && video.videoHeight > 0) syncMetadata();
      else orient(Boolean(video.dataset.mobilePoster) && window.matchMedia('(max-width: 600px)').matches);
    }
  };
  initialize(document);
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target instanceof Element) initialize(event.target);
  });
})();
